function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const segment = token.split('.')[1];
  if (!segment) return null;
  const normalized = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
  return JSON.parse(atob(padded));
}

// Token management utilities
export const TokenManager = {
  // Check if token is expired
  isTokenExpired: (token) => {
    if (!token) return true;

    try {
      const payload = decodeJwtPayload(token);
      if (!payload?.exp) return true;
      const currentTime = Date.now() / 1000;
      return payload.exp < currentTime;
    } catch (error) {
      console.error('Error checking token expiry:', error);
      return true;
    }
  },

  // Get token expiry time
  getTokenExpiry: (token) => {
    if (!token) return null;

    try {
      const payload = decodeJwtPayload(token);
      if (!payload?.exp) return null;
      return new Date(payload.exp * 1000);
    } catch (error) {
      console.error('Error getting token expiry:', error);
      return null;
    }
  },

  // Get time until token expires (in milliseconds)
  getTimeUntilExpiry: (token) => {
    const expiry = TokenManager.getTokenExpiry(token);
    if (!expiry) return 0;
    
    return expiry.getTime() - Date.now();
  },

  // Check if token will expire within a certain time (default 5 minutes)
  willExpireSoon: (token, thresholdMs = 5 * 60 * 1000) => {
    const timeUntilExpiry = TokenManager.getTimeUntilExpiry(token);
    return timeUntilExpiry <= thresholdMs;
  },

  // Clear all authentication data
  clearAuthData: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Dispatch event to notify other components
    window.dispatchEvent(new CustomEvent('auth:token-expired'));
  },

  // Setup automatic token expiry checking
  setupTokenExpiryCheck: (checkInterval = 60000) => { // Check every minute
    const checkToken = () => {
      const token = localStorage.getItem('token');
      if (token && TokenManager.isTokenExpired(token)) {

        TokenManager.clearAuthData();
        
        // Redirect to login if not already there
        if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
          window.location.href = '/login';
        }
      }
    };

    // Initial check
    checkToken();

    // Setup periodic checking
    const intervalId = setInterval(checkToken, checkInterval);

    // Return cleanup function
    return () => clearInterval(intervalId);
  }
}; 